import { graphql } from "react-relay";

export const fragments = {
  payload: graphql`
    fragment SuggestionActionRequestToMove_payload on SuggestionActionRequestToMovePayload {
      betterTime {
        date
        timeSlot
      }
      nearestAlternateTime {
        date
        timeSlot
      }
    }
  `,
};
